import {hashPassword} from 'kiss-crypto'

// We can re-use the same salts because hashed passwords are never
// shared with the server (they're only used for encryption)
export const ENCRYPTION_SALT = '7ac05285256da683c4aa863deae95fd3'

export const passwordToEncryptionKey = (password: string) => {
  return hashPassword({password, salt: ENCRYPTION_SALT})
}
